import(/* webpackMode: "eager", webpackExports: ["PortalHome"] */ "/vercel/path0/apps/game/app/games/portal-home.tsx");
